var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPassword = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.66797 13.333C1.66797 10.976 1.66797 9.79747 2.4002 9.06524C3.13243 8.33301 4.31095 8.33301 6.66797 8.33301H13.3346C15.6917 8.33301 16.8702 8.33301 17.6024 9.06524C18.3346 9.79747 18.3346 10.976 18.3346 13.333C18.3346 15.69 18.3346 16.8685 17.6024 17.6008C16.8702 18.333 15.6917 18.333 13.3346 18.333H6.66797C4.31095 18.333 3.13243 18.333 2.4002 17.6008C1.66797 16.8685 1.66797 15.69 1.66797 13.333Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 14.1667C7.1256 14.1667 7.4987 13.7936 7.4987 13.3333C7.4987 12.8731 7.1256 12.5 6.66536 12.5C6.20513 12.5 5.83203 12.8731 5.83203 13.3333C5.83203 13.7936 6.20513 14.1667 6.66536 14.1667Z",
    fill: "#818181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 14.1667C10.4589 14.1667 10.832 13.7936 10.832 13.3333C10.832 12.8731 10.4589 12.5 9.9987 12.5C9.53846 12.5 9.16536 12.8731 9.16536 13.3333C9.16536 13.7936 9.53846 14.1667 9.9987 14.1667Z",
    fill: "#818181"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1654 13.3333C14.1654 13.7936 13.7923 14.1667 13.332 14.1667C12.8718 14.1667 12.4987 13.7936 12.4987 13.3333C12.4987 12.8731 12.8718 12.5 13.332 12.5C13.7923 12.5 14.1654 12.8731 14.1654 13.3333Z",
    fill: "#818181"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 6.66699C5.625 4.25075 7.58375 2.29199 10 2.29199C12.4162 2.29199 14.375 4.25075 14.375 6.66699V8.33664C14.8478 8.34105 15.2612 8.352 15.625 8.37917V6.66699C15.625 3.56039 13.1066 1.04199 10 1.04199C6.8934 1.04199 4.375 3.56039 4.375 6.66699V8.37917C4.73876 8.352 5.1522 8.34105 5.625 8.33664V6.66699Z",
    fill: "#383838"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPassword);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Password.aec4273993a3d4bb987ce4f6654c88db.svg";